<section id="pageCover" class="row">
    <img src="../../../assets/images/contactCover.png" alt="" class="pageCover">
    <!--<div class="row pageTitle">Projects</div>-->
    <div class="row pageBreadcrumbs">
        <!--<ol class="breadcrumb">
            <li><a href="index.html">home</a></li>
            <li class="active">Projects</li>
        </ol>-->
    </div>
</section>

<section id="contacts" class="row">
    <div class="container">
        <div class="row">
            <div class="col-sm-6">
                <div class="row m0">
                    <h3>{{'Contactus' | translate}}</h3>
                    <p>
                        {{'aboutDes' | translate}}
                    </p>
                    <ul class="list-inline">
                        <li><i class="fa fa-home"></i> {{'address' | translate}} </li>
                        <li><a href="tel:00966599454045"><i class="fa fa-phone"></i> +966 59 945 4045</a></li>
                        <li><a href="mailto:info@misk-co.com"><i class="fa fa-envelope-o"></i> info@misk-co.com</a></li>
                    </ul>
                </div>
                <div class="row m0 commentForm">
                    <form class="row m0" id="contactForm" method="post" name="contact" action="contact_process.php">
                        <div class="col-sm-6 p0 commenterInfoInputs">
                            <div class="row m0">
                                <div class="input-group">
                                    <span class="input-group-addon"><i class="fa fa-user"></i></span>
                                    <input type="text" class="form-control" name="name" id="name" placeholder="{{'name' | translate}}">
                                </div>
                                <div class="input-group">
                                    <span class="input-group-addon"><i class="fa fa-envelope"></i></span>
                                    <input type="email" class="form-control" name="email" id="email" placeholder="{{'e-mail' | translate}}">
                                </div>
                                <div class="input-group">
                                    <span class="input-group-addon"><i class="icofont-web  fa-2x"></i></span>
                                    <input type="url" name="url" id="url" class="form-control" placeholder="{{'website' | translate}}">
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 p0">
                            <div class="row m0">
                                <div class="input-group">
                                    <textarea placeholder="{{'Message' | translate}}" name="message" id="message" class="form-control"></textarea>
                                </div>
                                <button class="btn btn-default" type="submit">{{'sendMessage' | translate}}</button>
                            </div>
                        </div>
                    </form>
                    <div id="success">
                        <span class="green textcenter">
                            <p>{{'successfullyMsg' | translate}}</p>
                        </span>
                    </div>
                    <div id="error">
                        <span>
                            <p>{{'wrong' | translate}}</p>
                        </span>
                    </div>
                </div>
            </div>
            <div class="col-sm-6">
                <h3>{{'Findus' | translate}}</h3>
                <div id="mapBox"></div>
            </div>
        </div>
    </div>
</section>